import cookie from "js-cookie";
const defaultState = {
  authorization: cookie.get("authorization") || undefined,
  userInfo: undefined,
  menuList: undefined,
  permissionList:[]
};

function authReducer(state = defaultState, action) {
  switch (action.type) {
    case "auth/login":
      return { ...state, authorization: action.payload };
    case "auth/logout":
      return {
        ...state,
        ...defaultState,
        authorization: "",
      };
    case "auth/userInfo":
      let userInfo = action.payload;
      let { menuList,permissionList } = userInfo || {};
      return { ...state, userInfo: action.payload, menuList,permissionList };
    default:
      return state;
  }
}
export default authReducer;
